import axios from "axios";
import { Navigate } from "react-router-dom";

const apiUrl = "https://backend.sansadkhelmahotsav.in/backend/";
// const apiUrl = "http://103.150.186.94:5001/";

const axiosInstance = axios.create({
  baseURL: apiUrl + "api/",
});

// Optional: Add interceptors for auth token, error logs etc.
axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("admin_token"); // or sessionStorage if you use that

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axiosInstance.interceptors.response.use(
  (response) => {
    const { code, message, data } = response.data || {};

    if (code === 400 && message === "Invalid or expired token") {
      localStorage.removeItem("token");
      Navigate("/");
    }

    return {
      code: code || 500,
      message: message || "Something went wrong! Try Again",
      data: data || null,
    };
  },
  (error) => {
    console.error("API Error:", error.response || error.message);
    return Promise.reject(error);
  }
);

export default axiosInstance;
